<script>
    import { onMount } from 'svelte';
    import { navigate } from 'svelte-routing';
    import { Tooltip } from 'sveltestrap';

    import { isAuthenticated, selectedAspect, filterShowTargetedInmatesOnly } from '../stores.js';
    import { config } from '../config.js';

    import CohortFilters from './CohortFilters.svelte';
    import OverallOverview from './overall/OverallOverview.svelte';
    import OverallList from "./overall/OverallList.svelte";
    import IsolationOverview from './isolation/IsolationOverview.svelte';
    import IsolationList from "./isolation/IsolationList.svelte";
    import SurveyOverview from './survey/SurveyOverview.svelte';
    import SurveyList from "./survey/SurveyList.svelte";
    import EarlyDaysOverview from './early-days/EarlyDaysOverview.svelte';
    import EarlyDaysList from './early-days/EarlyDaysList.svelte';
    import EarlyRiskList from "./early-risk/EarlyRiskList.svelte";
    import EarlyRiskOverview from "./early-risk/EarlyRiskOverview.svelte";
    import RiskFactorsOverview from './risk-factors/RiskFactorsOverview.svelte';
    import RiskFactorsList from './risk-factors/RiskFactorsList.svelte';

    let requestProperties;
    let areListsLoading;

    function updateRequest(event) {
        requestProperties = event.detail.requestProperties;
    }

    const refreshData = () => {
        requestProperties = requestProperties
    }

    onMount(() => {
        if (!($isAuthenticated)) {
            navigate("/");
        }
    });

    function setSelectedAspect(aspectName) {
        filterShowTargetedInmatesOnly.set(false);
        selectedAspect.set(aspectName);
    }
</script>

<style>
    :global(.establishment-banner) {
        top: 95px;
    }

    :global(.establishment-widget) {
    	margin-left: 10px;
        flex-grow: 0;
        flex-shrink: 0;
    }

    /* Breakdown Widgets */
    :global(.breakdown-widget) {
        height: 100px;
        display: flex;
        flex-grow: 1;
        align-items: center;
        justify-content: center;
    }

    :global(.breakdown-widget table) {
        margin-bottom: 0;
    }

    :global(.breakdown-widget .table td) {
        cursor: pointer;
        padding: 0 0 2px 0;
        text-align: right;
        font-size: 13px;
        font-weight: 600;
    }

    :global(.breakdown-widget .table td:first-of-type) {
    	text-align: left;
    }

    :global(.breakdown-widget .table td.card-legend-percentage) {
        color: #6c757d;
        font-weight: 100;
    }

    :global(.breakdown-widget .table td.card-legend-trend) {
        width: 30px;
        padding: 0;
    }

    :global(.breakdown-widget .table td.card-legend-trend span.trend-icon) {
        display: block;
        font-size: 18px;
        line-height: 18px;
    }

    :global(.breakdown-widget .table td img) {
        height: 20px;
    }

    /* Count Widgets */
    :global(.count-widget) {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
    }

    :global(.count-widget .count-widget-body) {
        height: 79px;
        padding-top: 2px;
    }

    :global(.count-widget .count-widget-body .card-flex-column div) {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }

    :global(.count-widget .count-widget-body span.targeted-count) {
        font-size: 28px;
        line-height: 36px;
        font-weight: 600;
    }
    
    :global(.count-widget .count-widget-body span.reduced-text) {
        font-size: 10px;
    }

    :global(.count-widget .count-widget-footer) {
        display: block;
        width: 100%;
        text-align: center;
        font-size: 14px;
        color: #6c757d;
    }

    :global(.count-widget .count-widget-footer img) {
        height: 18px;
        margin-bottom: 2px;
    }
</style>

<nav class="navbar fixed-top p-0">
    <button id="logo" type="button" class="button-reset focus-outline" on:click={refreshData}>
        <img src="/assets/logo-aim-target-white.png" alt="AIM Logo" />
    </button>
    <h1>
        <button type="button" class="button-reset focus-outline" on:click={refreshData}>{$config.establishmentName}</button>
        {#if $selectedAspect != "Overall"} &middot; {$selectedAspect}{/if}
    </h1>
</nav>

<CohortFilters on:update={updateRequest} {areListsLoading} />

<div class="banner establishment-banner">
    <OverallOverview on:click={() => {setSelectedAspect("Overall")}} {requestProperties}
        on:dataLoad={(event) => {areListsLoading = event.detail.isLoading}} />
    <EarlyRiskOverview on:click={() => {setSelectedAspect("Early Risk")}} {requestProperties} />
    <EarlyDaysOverview on:click={() => {setSelectedAspect(`${$config.earlyDaysLabelName} Engagement`)}} {requestProperties} />
    <IsolationOverview on:click={() => {setSelectedAspect("Isolation")}} {requestProperties}  />
    <SurveyOverview on:click={() => {setSelectedAspect($config.surveyLabelName)}} {requestProperties} />
    <RiskFactorsOverview on:click={() => {setSelectedAspect($config.riskFactorLabelName)}} {requestProperties} />
</div>

{#if $selectedAspect === "Overall"}
    <OverallList {requestProperties} on:refresh={refreshData} />
{/if}
{#if $selectedAspect === "Early Risk"}
    <EarlyRiskList {requestProperties} on:refresh={refreshData} />
{/if}
{#if $selectedAspect === `${$config.earlyDaysLabelName} Engagement`} 
    <EarlyDaysList {requestProperties} on:refresh={refreshData} />
{/if}
{#if $selectedAspect === "Isolation"}
    <IsolationList {requestProperties} on:refresh={refreshData} />
{/if}
{#if $selectedAspect === $config.surveyLabelName}
    <SurveyList {requestProperties} on:refresh={refreshData} />
{/if}
{#if $selectedAspect === $config.riskFactorLabelName}
    <RiskFactorsList {requestProperties} on:refresh={refreshData} />
{/if}

{#if $config.footerText}
    <footer class="footer fixed-bottom d-flex justify-content-center">
        <p class="my-2">{$config.footerText}</p>
    </footer>
{/if}